import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ Import this
import { GoogleOAuthProvider } from '@react-oauth/google';

// ✅ Your Google OAuth client ID
const GOOGLE_CLIENT_ID = "449553893680-k8rh22daa23ah16r4qam8k24m2s92eqe.apps.googleusercontent.com";

ReactDOM.render(
    <React.StrictMode>
        {/* ✅ Wrap the app with provider */}
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <App />
        </GoogleOAuthProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
